export const MOSQUE = {
  name: "Jama Masjid Dariyapur",
  shortName: "Jama Masjid",
  village: "Dariyapur",
  district: "Bihar",
  country: "India",
  defaultLatitude: Number(import.meta.env.VITE_DEFAULT_LAT ?? 25.6093),
  defaultLongitude: Number(import.meta.env.VITE_DEFAULT_LNG ?? 85.1376),
} as const;

export const WHATSAPP_INVITE_URL =
  "https://chat.whatsapp.com/JpCcmq1GkhM1hkn7pUuaeD";


export const DEVELOPMENT_PROJECT_SLUGS = [
  "first-floor",
  "minar",
  "gumbad",
  "finishing-work",
  "MEP-work",
] as const;

export type DevelopmentProjectSlug = (typeof DEVELOPMENT_PROJECT_SLUGS)[number];

export const DEVELOPMENT_PROJECT_LABELS: Record<DevelopmentProjectSlug, string> = {
  "first-floor": "First Floor Construction",
  "minar": "Minar Construction",
  "gumbad": "Gumbad Construction",
  "finishing-work": "Finishing & Interior Work",
  "MEP-work": "Electrical & Plumbing Work",
};
